// extracted by mini-css-extract-plugin
module.exports = {"label":"formSelect_label__3H5oG","select":"formSelect_select__1s4ET"};